import { useState, useEffect } from "react";
import yesIcon from "../../assets/Resources/Images/NewTickPng.png";
import noIcon from "../../assets/Resources/Images/NewCrossPng.png";
import AllPageFooter from "./AllPageFooter";

const DoubleDoorDetailPage = ({
  doorData,
  complianceList,
  imageProxyBaseUrl,
  preReq,
  pageNum,
  logodata
}) => {
  const [doorStaticImageUrl, setDoorStaticImageUrl] = useState("");
  const [doorDetails, setDoorDetails] = useState({});
  // console.log("inside door detail");
  const isNullOrWhiteSpace = (str) => {
    return str == null || str.trim() === "";
  };

  const baseUrl = window.location.origin;
  const surveyUrl = `${baseUrl}/client/${preReq.clientnameParam}/viewSurvey/${preReq.propertyMasterId}/${preReq.inspectionReferenceNumber}/${doorData?.doorRefNumber}`;

  useEffect(() => {
    const loadDoorData = async () => {
      //static image

      if (!doorData?.doorStaticImage) return;

      const doorstatic = doorData.doorStaticImage.trim();

      // ✅ Already data URI
      if (doorstatic.startsWith("data:")) {
        setDoorStaticImageUrl(doorstatic);
      }

      // ✅ Full URL
      else if (
        doorstatic.startsWith("http://") ||
        doorstatic.startsWith("https://")
      ) {
        setDoorStaticImageUrl(`${imageProxyBaseUrl}${doorstatic}`);
      }

      // ✅ Base64 string
      else if (
        doorstatic.length > 100 &&
        /^[A-Za-z0-9+/=]+$/.test(doorstatic)
      ) {
        setDoorStaticImageUrl(`data:image/png;base64,${doorstatic}`);
      }

      // ✅ Relative path → fetch it
      else {
        try {
          const normalizedPath = doorstatic
            .replace(/\\/g, "/")
            .replace(/^\/+/, "");

          const imagePath = `/assets/${normalizedPath}`; // ✅ IMPORTANT FIX

          const exists = await checkImageExists(imagePath);

          if (exists) {
            try {
              // ✅ Convert to Base64 only if image exists
              const response = await fetch(imagePath);
              const blob = await response.blob();

              const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              });

              setDoorStaticImageUrl(base64);
            } catch (err) {
              console.error("Base64 conversion failed:", err);
              setDoorStaticImageUrl(imagePath); // fallback to normal URL
            }
          } else {
            const replaceImage = await findFallbackImage(imagePath);
            try {
              // ✅ Convert to Base64 only if image exists
              const response = await fetch(replaceImage);
              const blob = await response.blob();

              const base64 = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
              });

              setDoorStaticImageUrl(base64);
            } catch (err) {
              console.error("Base64 conversion failed:", err);
              setDoorStaticImageUrl(imagePath); // fallback to normal URL
            }
          }
        } catch (err) {
          console.error("Image load failed:", err);

          // fallback

          setDoorStaticImageUrl(`${imageProxyBaseUrl}${doorstatic}`);
        }
      }

      // Self Closing / Glazing - Use DoorGlaze column directly
      let doorDetailsObj = {};
      const doorCompliancesList = complianceList;

      const selfClosingDevice = doorCompliancesList?.some(
        (c) =>
          c?.checkListName &&
          c.checkListName.trim().toLowerCase() === "self closing device?" &&
          c.isCompliant === true,
      );
      // Use DoorGlaze column: if "No", show "No", otherwise show "Yes"
      const doorGlazeValue = (doorData?.doorGlaze ?? "").trim();
      const glazingText = doorGlazeValue?.toLowerCase() === "no" ? "No" : "Yes";
      const selfClosingText = selfClosingDevice ? "Yes" : "No";
      const complaintText =
        doorData?.totalActionItems > 0 ? "Non-Compliant" : "Compliant";
      const complianceOk = doorData?.totalActionItems <= 0;
      doorDetailsObj.glazingText = glazingText;
      doorDetailsObj.complaintText = complaintText;
      doorDetailsObj.selfClosingText = selfClosingText;
      doorDetailsObj.complianceOk = complianceOk;

      //double door Gaps(kept)

      const fmt = (v) => {
        if (v === null) return "0.0";

        const num = parseFloat(String(v ?? ""));

        if (!isNaN(num)) {
          return num.toFixed(1);
        } else {
          return "0.0";
        }
      };
      const leftHeadVal = fmt(doorData?.leftHead?.value);
      const rightHeadVal = fmt(doorData?.rightHead?.value);
      const leftHingeVal = fmt(doorData?.leftHinge?.value);
      const rightHingeVal = fmt(doorData?.rightHinge?.value);
      const leftThresholdVal = fmt(doorData?.leftThreshold?.value);
      const rightThresholdVal = fmt(doorData?.rightThreshold?.value);
      const closingVal = fmt(doorData?.closing?.value);

      doorDetailsObj.leftHeadVal = leftHeadVal;
      doorDetailsObj.rightHeadVal = rightHeadVal;
      doorDetailsObj.closingVal = closingVal;
      doorDetailsObj.leftHingeVal = leftHingeVal;
      doorDetailsObj.rightHingeVal = rightHingeVal;
      doorDetailsObj.leftThresholdVal = leftThresholdVal;
      doorDetailsObj.rightThresholdVal = rightThresholdVal;

      /* Compliance ordering + visibility rules (same as your code) */

      const get = (label) => {
        const item = doorCompliancesList?.find(
          (c) =>
            typeof c?.checkListName === "string" &&
            c.checkListName.trim().toLowerCase() === label.toLowerCase(),
        );

        return item ? item.isCompliant : null;
      };
      const hasSelfClosingDevice = get("Self closing device?") ?? false;
      const hasFireShutSign = get("Fire door Keep Shut sign?") ?? false;
      const showColdSmokeSeals =
        !isNullOrWhiteSpace(doorData?.fireRating) &&
        (doorData?.fireRating === "60S" ||
          doorData?.fireRating === "90S" ||
          doorData?.fireRating === "30S");
      const showKeepLockedSign = !hasSelfClosingDevice;
      const showHoldOpenDevice = !hasFireShutSign;
      // Use DoorGlaze column: show pyro glazing if DoorGlaze is not "No"
      const showPyroGlazing = !(doorGlazeValue.toLowerCase() === "no");
      const uiOrder = [
        "Are there intumescent strips?",
        "Are there cold smoke seals?",
        "Self closing device?",
        "Fire door Keep Locked sign?",
        "Fire door Keep Shut sign?",
        "Is there a hold open device?",
        "Is certification visible on fire door?",
        "Is glazing pyro glazing?",
        "Does the door close fully?",
        "Any damage to the door?",
        "Any visual defects on the door?",
        "Does the door fit correctly within the frame?",
        "Any damage to the frame?",
        "Are all hinges fire rated?",
      ];

      const orderIndex = {};

      for (let i = 0; i < uiOrder.length; i++) {
        const k = (uiOrder[i] ?? "").trim().toLowerCase();

        if (!(k in orderIndex)) {
          orderIndex[k] = i;
        }
      }

      const rank = (label) => {
        if (!label || !label.trim()) return Number.MAX_SAFE_INTEGER;

        const k = label.trim().toLowerCase();

        return k in orderIndex ? orderIndex[k] : Number.MAX_SAFE_INTEGER;
      };

      const ordered = doorCompliancesList
        ?.filter((c) => c?.checkListName && c.checkListName.trim())
        .sort((a, b) => rank(a.checkListName) - rank(b.checkListName));

      const filtered = ordered
        ?.filter(
          (c) =>
            c.checkListName.trim().toLowerCase() !==
              "are there cold smoke seals?".toLowerCase() || showColdSmokeSeals,
        )
        .filter(
          (c) =>
            c.checkListName.trim().toLowerCase() !==
              "fire door keep locked sign?".toLowerCase() || showKeepLockedSign,
        )
        .filter(
          (c) =>
            c.checkListName.trim().toLowerCase() !==
              "is there a hold open device?".toLowerCase() ||
            showHoldOpenDevice,
        )
        .filter(
          (c) =>
            c.checkListName.trim().toLowerCase() !==
              "is glazing pyro glazing?".toLowerCase() || showPyroGlazing,
        )
        .filter(
          (c) =>
            c.checkListName.trim().toLowerCase() !==
            "does the door contain glazing?".toLowerCase(),
        );
      doorDetailsObj.filtered = filtered;

      setDoorDetails(doorDetailsObj);
    };

    loadDoorData();
  }, [doorData, imageProxyBaseUrl, complianceList]);

  const findFallbackImage = async (path) => {
    if (!path) return null;

    const fullPath = path.replace(/\\/g, "/");

    // ✅ Extract parts
    const parts = fullPath.split("/");
    const fileName = parts.pop();
    const directory = parts.join("/");

    // ✅ Match number in filename (-5-)
    const match = fileName.match(/-(\d+)-/);

    if (!match) {
      return `/assets/${fullPath}`;
    }

    const doorNumber = parseInt(match[1], 10);

    // ✅ Try fallback numbers (4 → 2)
    for (let i = doorNumber - 1; i >= 2; i--) {
      const fallbackFileName = fileName.replace(`-${doorNumber}-`, `-${i}-`);

      const fallbackPath = `${directory}/${fallbackFileName}`;
      const url = `/assets/${fallbackPath}`;

      const exists = await checkImageExists(url);

      if (exists) {
        return url; // ✅ Found working fallback
      }
    }

    // ❌ Nothing found → fallback to proxy
    const fallpath = `/assets/Resources/DoubleDoors/steel-8-grey.png`;
    return fallpath;
  };

  const checkImageExists = (url) => {
    return new Promise((resolve) => {
      const img = new Image();

      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);

      img.src = url;
    });
  };
  // console.log('[age num', pageNum)

  return (
    <>
      <div className="page sheet double-door-detail-wrapper">
        <table className="hdr">
          <tr>
            <td className="hdrL">
              <div className="hdrTitle">Flat Doors</div>
              <p className="hdrDesc">
                Door Location: Floor - {doorData.floorNo}{" "}
                {isNullOrWhiteSpace(doorData.doorLocation)
                  ? ""
                  : " - " + doorData.doorLocation}
              </p>
            </td>
            <td className="hdrR">
              <div className="qrBox">
                {!isNullOrWhiteSpace(doorData?.surveyQRCodeBase64) ? (
                  <img
                    className="qrPlaceholder"
                    src={doorData?.surveyQRCodeBase64}
                    alt="QR Code"
                  />
                ) : (
                  <div className="qrPlaceholder"></div>
                )}
              </div>
              <div className="qrRef">
                {!isNullOrWhiteSpace(preReq.clientnameParam) &&
                !isNullOrWhiteSpace(preReq.propertyMasterId) &&
                !isNullOrWhiteSpace(preReq.inspectionReferenceNumber) ? (
                  <a
                    href={surveyUrl}
                    style={{ color: "#000", textDecoration: "none" }}
                  >
                    {doorData?.doorRefNumber}
                  </a>
                ) : (
                  doorData?.doorRefNumber
                )}
              </div>
            </td>
          </tr>
        </table>
        <div className="hdrRule"></div>
        <div className="mainBlock">
          <div className="doorDiagram">
            {!isNullOrWhiteSpace(doorStaticImageUrl) && (
              <img
                className="doorImg"
                src={doorStaticImageUrl}
                alt="Door Diagram"
              />
            )}
            <div className="gapTag gapHeadLeft">
              Head {doorDetails?.leftHeadVal} mm
            </div>
            <div className="gapTag gapHeadCenter">
              Closing {doorDetails?.closingVal} mm
            </div>
            <div className="gapTag gapHeadRight">
              Head {doorDetails?.rightHeadVal} mm
            </div>
            <div className="gapTag gapLeft">
              Hinge {doorDetails?.leftHingeVal} mm
            </div>
            <div className="gapTag gapRight">
              Hinge {doorDetails?.rightHingeVal} mm
            </div>
            <div className="gapTag gapBottomLeft">
              Threshold {doorDetails?.leftThresholdVal} mm
            </div>
            <div className="gapTag gapBottomCenter">
              Closing {doorDetails?.closingVal} mm
            </div>
            <div className="gapTag gapBottomRight">
              Threshold {doorDetails?.rightThresholdVal} mm
            </div>
          </div>
          <div className="actionsBox">
            <div className="actionsNum">
              {!isNullOrWhiteSpace(preReq?.clientnameParam) ? (
                <a
                  href={`${window.location.origin}/client/${preReq?.clientnameParam}/actionRemediation?DoorReferenceNumber=${encodeURIComponent(doorData?.doorRefNumber ?? "")}`}
                  style={{ color: "#000", textDecoration: "none" }}
                >
                  {doorData?.totalActionItems ?? ""}
                </a>
              ) : (
                (doorData?.totalActionItems ?? "")
              )}
            </div>
            <div className="actionsTxt">Actions Required</div>
          </div>
          <table className="specZebraTwoCol">
            <tbody>
              <tr
                className={
                  doorDetails?.complianceOk
                    ? "compRowInTable ok"
                    : "compRowInTable"
                }
              >
                <td className="k">Compliance</td>
                <td className="v">{doorDetails?.complaintText}</td>
                <td className="k2">Fire Resistance</td>
                <td className="v2">{doorData?.fireRating ?? "-"}</td>
              </tr>
              <tr>
                <td className="k">Hinge Location</td>
                <td className="v">{doorData?.hingeLocation ?? "-"}</td>
                <td className="k2">Self-closing Devices</td>
                <td className="v2">{doorDetails?.selfClosingText}</td>
              </tr>
              <tr>
                <td className="k">Door Thickness (mm)</td>
                <td className="v">{doorData?.doorThickness?.value ?? "-"}</td>
                <td className="k2">
                  Full Doorset Size (Frame &amp; Leaf) (mm)
                </td>
                <td className="v2">
                  {doorData?.fullDoorsetSize?.value ?? "-"}
                </td>
              </tr>
              <tr>
                <td className="k">Door Height (mm)</td>
                <td className="v">{doorData?.doorHeight?.value ?? "-"}</td>
                <td className="k2">Door Width (mm)</td>
                <td className="v2">{doorData?.doorWidth?.value ?? "-"}</td>
              </tr>
              <tr>
                <td className="k">Colour of Door</td>
                <td className="v">
                  {!isNullOrWhiteSpace(doorData?.doorColor)
                    ? doorData?.doorColor
                    : "-"}
                </td>
                <td className="k2">Door Material</td>
                <td className="v2">
                  {!isNullOrWhiteSpace(doorData?.doorMaterial)
                    ? doorData?.doorMaterial
                    : "-"}
                </td>
              </tr>
              <tr>
                <td className="k">Glazing</td>
                <td className="v">{doorDetails?.glazingText}</td>
                <td className="k2">Floor / Location</td>
                <td className="v2">
                  Floor {doorData?.floorNo} / {doorData?.doorLocation}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <AllPageFooter pageNumber={pageNum?.[0]} propLogo={logodata?.propShieldLogoBase64} />
      </div>
      <div className="page sheet double-door-detail-wrapper">
        <table className="hdr">
          <tr>
            <td className="hdrL">
              <div className="hdrTitle">Flat Doors</div>
              <p className="hdrDesc">
                Door Location: Floor - {doorData.floorNo}{" "}
                {isNullOrWhiteSpace(doorData.doorLocation)
                  ? ""
                  : " - " + doorData.doorLocation}
              </p>
            </td>
            <td className="hdrR">
              <div className="qrBox">
                {!isNullOrWhiteSpace(doorData?.surveyQRCodeBase64) ? (
                  <img
                    className="qrPlaceholder"
                    src={doorData?.surveyQRCodeBase64}
                    alt="QR Code"
                  />
                ) : (
                  <div className="qrPlaceholder"></div>
                )}
              </div>
              <div className="qrRef">
                {!isNullOrWhiteSpace(preReq.clientnameParam) &&
                !isNullOrWhiteSpace(preReq.propertyMasterId) &&
                !isNullOrWhiteSpace(preReq.inspectionReferenceNumber) ? (
                  <a
                    href={surveyUrl}
                    style={{ color: "#000", textDecoration: "none" }}
                  >
                    {doorData?.doorRefNumber}
                  </a>
                ) : (
                  doorData?.doorRefNumber
                )}
              </div>
            </td>
          </tr>
        </table>
        <div className="hdrRule"></div>
        <table className="chkTbl">
          {doorDetails?.filtered?.map((c, i) => {
            const iconSrc = c.isCompliant ? yesIcon : noIcon;
            return (
              <tr key={`double-${i}`}>
                <td className="chkI">
                  <img
                    className="chkIcon"
                    src={iconSrc}
                    alt={c.IsCompliant ? "Yes" : "No"}
                  />
                </td>
                <td className="chkT">{c?.checkListName}</td>
              </tr>
            );
          })}
        </table>
        <AllPageFooter pageNumber={pageNum?.[1]} propLogo={logodata?.propShieldLogoBase64} />
      </div>
    </>
  );
};

export default DoubleDoorDetailPage;
